import { Fragment } from 'react';

export function UpgradingAndDowngradingSubscriptions() {
  return (
    <Fragment>
      Users are free to upgrade or downgrade their subscriptions at will. All changes can be tracked through the Subscription Portal, and all transactions will be handled by our third-party payment operator. 
      <br /><br />
      Pricing for upgrades or downgrades may be different than advertised, as pricing changes (see <em>Right to Change Subscription Fees Payable</em>) may already be in effect while promotional materials have not yet been updated.
      <br /><br />
      <em>Upgrades</em><br />
      Features available after an upgrade will be available immediately upon our receipt of the User’s payment. The amount due will be calculated as the difference between the current subscription plan and the purchased plan, pro-rated for the time from the payment until the next billing cycle. The next billing cycle will be paid in full at the upgraded plan price.
      For example, a lower-tier plan User who upgrades to a higher-tier plan with 10 days until the next billing cycle will pay the difference between the lower and higher-tier plans pro-rated at 10/30 for the first 10 days. The full cost of the higher-tier plan will be charged at the start of the new billing cycle.
      <br /><br />
      <em>Downgrades</em><br />
      Downgrades will not take effect until the next billing cycle, so users who downgrade will be able to enjoy the features of the higher-rated plan until the next billing cycle. No full or partial refunds will be granted for Users who downgrade in the middle of a billing cycle, including annual or biannual subscribers.
    </Fragment>
  );
}


export default UpgradingAndDowngradingSubscriptions;
